import { render, staticRenderFns } from "./FamilyList.vue?vue&type=template&id=453bdf04&"
import script from "./FamilyList.vue?vue&type=script&lang=js&"
export * from "./FamilyList.vue?vue&type=script&lang=js&"
import style0 from "./FamilyList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports